import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../models/DefaultResponse";

@Injectable({
  providedIn: 'root'
})
export class SubCategoriaService{
  private api = ConvivaApi;

  constructor(
    private http: HttpClient)
  { }

  public getSubCategoria():Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.SubCategoria.getSubCategoria}`)
                    .pipe(map((response: DefaultResponse) => response));
  }

  public fixDescricaoSubCategoria(codigoSubCategoria: number, descSubCategoria: string):Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.SubCategoria.fixDescricaoSubCategoria}?CodigoSubCategoria=${codigoSubCategoria}&DescSubCategoria=${descSubCategoria}`)
                    .pipe(map((response: DefaultResponse) => response));
  }
}
